// extracted by mini-css-extract-plugin
export default {"container":"uqkm_"};